'use client';
type User = {
  email: string | null;
  first_name: string;
  hasEmail: boolean;
  last_name: string;
  telephone: string;
};
interface Props {
  user: User;
}

import { useState } from 'react';
import DeleteAccountButton from './DeleteAccountButton';

export default function UserProfile({ user }: Props) {
  return (
    <div className="max-w-md md:max-w-2xl py-10 bg-white">
      <form className="space-y-5">
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Name
          </label>
          <input
            type="text"
            value={`${user.first_name} ${user.last_name}`}
            disabled
            className="w-full mt-1 rounded-md border-gray-300 bg-gray-100 p-2 text-sm focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            E-mail Address
          </label>
          <input
            type="email"
            value={user.hasEmail ? (user.email ?? '') : ''}
            disabled
            className="w-full mt-1 rounded-md border-gray-300 bg-gray-100 p-2 text-sm focus:outline-none"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700">
            Phone number
          </label>
          <input
            type="text"
            value={user.telephone}
            disabled
            className="w-full mt-1 rounded-md border-gray-300 bg-gray-100 p-2 text-sm focus:outline-none"
          />
        </div>

        <div className="flex gap-4 pt-3 mt-4">
          <button
            type="button"
            className="border border-gray-500 px-4 py-2 text-sm rounded-md hover:bg-gray-100"
          >
            Edit Profile
          </button>
          <DeleteAccountButton />
        </div>
      </form>
    </div>
  );
}
